import { Injectable } from '@angular/core';
import { DokumentSearchParams } from '@features/dokumenter/dokument-search/dokument-search-params.model';
import { TableDatasource } from '@core/api/table.datasource';
import { Dokument } from './dokument.model';

@Injectable({
  providedIn: 'root',
})
export class DokumentDatasource extends TableDatasource<
  Dokument,
  DokumentSearchParams
> {
  endpoint = '/api/admin/dokumenter';
  defaultSortField = 'oprettelsesTidspunkt';
  override defaultDescending = true;
}
